








































import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: {} }) data: any;
  form: any = {};
  Url = XMLHTTP_BASEURL;
  maxlength = 0;
  pdfUrlList: any = [];
  maxPdflength = 0;
  pdfUrl: string = "";
  pdfIndex = 0;
  pdfName = "";
  showPdfName = true;
  created() {
    this.form = Object.assign({}, this.data);
    if (this.form.pdfList) {
      this.pdfUrlList = this.form.pdfList;
      this.maxPdflength = this.pdfUrlList.length;
      this.pdfName = this.pdfUrlList[0].fileName;
      this.pdfUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(
        this.Url + this.pdfUrlList[0].fileUrl
      )}`;
    }
  }
  setPdfUrl() {
    this.showPdfName = false;
    if (this.pdfIndex >= this.maxPdflength) {
      this.pdfIndex = this.maxPdflength;
    }
    if (this.pdfIndex <= 1) {
      this.pdfIndex = 1;
    }
    this.pdfName = this.pdfUrlList[this.pdfIndex - 1].fileName;
    this.pdfUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(
      this.Url + this.pdfUrlList[this.pdfIndex - 1].fileUrl
    )}`;

    this.showPdfName = true;
  }
  rules = {};
  nextPdf() {
    this.showPdfName = false;
    if (this.pdfIndex + 1 > this.maxPdflength) {
      this.pdfIndex = 1;
    } else {
      this.pdfIndex++;
    }
    this.pdfName = this.pdfUrlList[this.pdfIndex - 1].fileName;
    this.pdfUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(
      this.Url + this.pdfUrlList[this.pdfIndex - 1].fileUrl
    )}`;
    this.showPdfName = true;
  }
  previousPdf() {
    this.showPdfName = false;
    if (this.pdfIndex <= 1) {
      this.pdfIndex = this.maxPdflength;
    } else {
      this.pdfIndex--;
    }
    this.pdfName = this.pdfUrlList[this.pdfIndex - 1].fileName;
    this.pdfUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(
      this.Url + this.pdfUrlList[this.pdfIndex - 1].fileUrl
    )}`;
    this.showPdfName = true;
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  recordClick(index: number) {
    this.pdfIndex = index;
    this.pdfUrl = `/pdf/web/viewer.html?file=${encodeURIComponent(
      this.Url + this.pdfUrlList[this.pdfIndex].fileUrl
    )}`;
  }
  get headers() {
    return {
      "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie(),
      Authorization: "Bearer " + window.abp.auth.getToken(),
      "X-Frame-Options": "SAMEORIGIN"
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdMedicalLiterature/pdfShow.vue